import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/crm/leave/apply";

/**
 * 请假申请页接口
 * 假别下拉、部门下拉走 commonApi
 */
export default {
    /** 查询请假单列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 申请一个编码，用作新增请假单的 id（工作流拦截器要用它做 biz_key） */
    applyCode: () => axios.get({url: `${PREFIX_URI}/applyCode`}),
    /** 查询请假单详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 保存草稿 */
    saveDraft: (data) => axios.post({url: `${PREFIX_URI}/saveDraft`, data}),
    /** 保存并提交审批 */
    saveSubmit: (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data}),
    /** 撤回 */
    withdrawLeave: (id) => axios.post({url: `${PREFIX_URI}/withdrawLeave`, data: {id}}),
    /** 删除 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 查询请假申请页的 KPI 与分布图 */
    stat: (data) => axios.get({url: `${PREFIX_URI}/stat`, data}),
    /**
     * 查询本单据的审批流转记录（列表「查看审批」用）。
     * 业务类型由服务端写死为 LeaveApplication，前端只传单据 id。
     */
    queryFlowInstance: (id) => axios.get({url: `${PREFIX_URI}/queryFlowInstance`, data: {id}}),
}
